<template>
  <ul class="faq-accordion">
    <li
      v-for="({id, question, response}, index) in items"
      class="pave-faq"
      :key="id"
      @click="toggleOpen(index)"
    >
      <h3
        class="pave-head"
        :class="{ open: opened[index] }"
      >
        {{ question }}
      </h3>
      <transition name="slide">
        <div
          class="pave-content rte"
          v-show="opened[index]"
          v-html="response"
        ></div>
      </transition>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'FaqAccordion',

  props: {
    items: Array
  },

  data () {
    return {
      opened: this.items.map(x => false)
    }
  },

  methods: {
    toggleOpen: function (index) {
      this.$set(this.opened, index, !this.opened[index])
    }
  }
}
</script>
